{
    "serverDownErrorMessage": "The server is currently unavailable. Please try again later.",
    "goToDashboard": "Go To Dashboard",
    "serverDown": "serverDown",
    "serverDownText": "Server Down"
}